import Vue from 'vue';
import moment from 'moment';
import store from '@/store';
import ORDER_TYPES from '@/models/orderTypes';
import PieceShipmentModel from '../../models/pieceShipment.model';

/* eslint-disable camelcase */
/* eslint-disable class-methods-use-this */
/* eslint-disable prefer-const */

export default class CalculateService {
  async calculatePrices() {
    const bodyRequest = this.preparePricesRequest();
    const result = await Vue.api.request(
      'api/calculateprice',
      'POST',
      bodyRequest,
    );
    store.dispatch('preparation/updateCalculateResultStored', result);
    return result;
  }

  calculateProducts() {
    const bodyRequest = this.prepareProductsRequest();
    return Vue.api.request('api/calculateProducts', 'POST', bodyRequest);
  }

  prepareLocationsData() {
    const { locationFrom, locationTo } = store.state.preparation;
    let {
      DctCityName: city_from,
      CountryCode: country_code_from,
      PostalCode: postal_code_from,
      FacilityCode: facility_code_from,
      NonDhlCode: non_dhl_code_from,
      autoPostal: autoPostalFrom,
    } = this.changePostfixNeeded(locationFrom);

    if (!postal_code_from) {
      postal_code_from = autoPostalFrom;
    }

    let {
      DctCityName: city_to,
      CountryCode: country_code_to,
      PostalCode: postal_code_to,
      FacilityCode: facility_code_to,
      NonDhlCode: non_dhl_code_to,
      autoPostal: autoPostalTo,
    } = this.changePostfixNeeded(locationTo);

    if (!postal_code_to) {
      postal_code_to = autoPostalTo;
    }

    return {
      city_from,
      country_code_from,
      postal_code_from,
      facility_code_from,
      non_dhl_code_from,
      city_to,
      country_code_to,
      postal_code_to,
      facility_code_to,
      non_dhl_code_to,
    };
  }

  // eslint-disable-next-line class-methods-use-this
  changePostfixNeeded(local) {
    let postalCode = local.PostalCode || local.autoPostal;
    if (local.PostfixNeeded === 1) {
      postalCode += local.Postfix;
    }

    return {
      ...local,
      PostalCode: postalCode,
    };
  }

  preparePricesRequest() {
    const locations = this.prepareLocationsData();

    const { calcDeliverySet } = store.state.preparation;
    const { token } = calcDeliverySet;
    const { pieces } = store.state.preparation;

    const preparationPieces = PieceShipmentModel.createFromPieceModels(pieces);

    return {
      token,
      ...locations,
      pieces: preparationPieces,
    };
  }

  prepareProductsRequest() {
    const {
      locationFrom,
      locationTo,
      servicePointFrom,
      orderType,
      pieces,
      pickUpRange,
      invoice,
    } = store.state.preparation;

    const {
      sessionSettings,
    } = store.state.common;

    const {
      DctCityName: shp_city_id,
      CountryCode: shp_country,
      PostalCode: shp_postal_code,
      IsServicePoint,
    } = this.changePostfixNeeded(locationFrom);

    const {
      DctCityName: rec_city_id,
      CountryCode: rec_country,
      PostalCode: rec_postal_code,
      IsPointToPoint,
    } = this.changePostfixNeeded(locationTo);

    const preparationPieces = PieceShipmentModel.createFromPieceModels(pieces);
    const servicePointRoute = (servicePointFrom && servicePointFrom.route) || null;
    const date = moment(pickUpRange.date).format('YYYY-MM-DD');
    const readyTime = moment(pickUpRange.timeFrom).format('H:mm');
    const { timeZone } = pickUpRange;

    const { USDtoEUR, RUBtoEUR } = sessionSettings.customsDuty;

    let insured_value = 0;

    switch (invoice.currency) {
      case 'EUR':
        insured_value = parseFloat(invoice.price * RUBtoEUR).toFixed(2);
        break;
      case 'USD':
        insured_value = parseFloat(invoice.price * USDtoEUR * RUBtoEUR).toFixed(2);
        break;
      case 'RUB':
      default:
        insured_value = parseFloat(invoice.price).toFixed(2);
        break;
    }

    return {
      date,
      is_point_to_point: !!IsPointToPoint,
      is_service_point: !!IsServicePoint,
      pieces: preparationPieces,
      insured_value,
      pickup_from_time: readyTime,
      shp_windows_time_zone_id: timeZone,
      rec_city_id,
      rec_country,
      rec_postal_code,

      shp_city_id,
      shp_country,
      shp_postal_code,
      insured_value: 10000.00,

      office_route: servicePointRoute,
      type: orderType,

    };
  }

  /**
   * Определение изменения результатов расчета
   * @param calculatePrices
   * @param calculateProducts
   */
  checkCalculationDifference(calculatePrices, calculateProducts) {
    let result = {
      price: false,
      date: false,
      continue: true,
    };

    const { orderType } = store.state.preparation;
    if (orderType === ORDER_TYPES.WALK_TYPE) {
      const productWalkType = calculateProducts.walk
        ? calculateProducts.walk
        : calculateProducts;
      result = this.checkDifferenceOrderType(
        calculatePrices.walk,
        productWalkType,
      );
    } else if (orderType === ORDER_TYPES.CLICK_TYPE) {
      // eslint-disable-next-line max-len
      const productClickType = calculateProducts.click
        ? calculateProducts.click
        : calculateProducts;
      result = this.checkDifferenceOrderType(
        calculatePrices.click,
        productClickType,
      );
    } else if (orderType === ORDER_TYPES.CALL_TYPE) {
      const productCallType = calculateProducts.call
        ? calculateProducts.call
        : calculateProducts;
      result = this.checkDifferenceOrderType(
        calculatePrices.call,
        productCallType,
      );
    }

    store.dispatch('preparation/setPriceDiff', result);
  }

  checkDifferenceOrderType(calculatePrices, calculateProducts) {
    const oldPrice = calculatePrices ? calculatePrices.price : null;
    const oldData = calculatePrices ? calculatePrices.delivery_date : '';

    let newPrice = null;
    if (calculateProducts && calculateProducts.shipping_charge) {
      newPrice = calculateProducts.shipping_charge;
    } else if (calculateProducts && calculateProducts.price) {
      newPrice = calculateProducts.price;
    }

    const newFullData = calculateProducts
      ? calculateProducts.delivery_date
      : '';
    const newData = newFullData ? newFullData.split('T')[0] : '';

    return {
      price: oldPrice !== newPrice,
      data: oldData !== newData,
      continue: !(newPrice === null || newData === null),
    };
  }
}
